module.exports = __WEBPACK_EXTERNAL_MODULE_core_Materials_effect__;